import React, { useState, useEffect } from 'react';
import { Icon } from '@b-design/fusion';
import Button from '@/components/Button';
import { Balloon } from '@alifd/next';
import Requests from '@/services/request';
import $i18n from '@/i18n';
import CalculateComponent from '@/components/CalculateComponent';
import CreateDrawer from '../createDrawer';
import { getQueryStringArgs } from '@/utils/url-parse';
import DragList from '../dragList';

import './index.less';
const Tooltip = Balloon.Tooltip;

const CategoryList: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [, setContentHeight] = useState(296);
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showDrawer, spaceId } = getQueryStringArgs();
  const [detailDataSource, setDetailDataSource] = useState({});
  const [editStatus, setEditStatus] = useState('create');

  useEffect(() => {
    if (showDrawer) {
      setVisible(true);
    }
  }, [showDrawer]);

  useEffect(() => {
    initData();
  }, []);

  /**
   * 初始化表单数据请求
   */
  const initData = () => {
    if (!spaceId) {
      return;
    };
    setLoading(true);
    Requests.post('/rest/intercnn/space/category/list', { spaceId })
      .then((res) => {
        const data = res || [];
        data.sort((a,b)=>{return a.sort-b.sort})
        setDataSource(data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const onChange = (v) => {
  //   setCategoryType(v);
  // };

  return (
    <div className="list-content">
      <div className="content-btns-filter">
        <Button
          type="primary"
          data-child-type="icon-text"
          id="btn-create-miniapp"
          onClick={() => {setVisible(true);setEditStatus('create')}}
        >
          <Icon type="add--circle--filled" />
          {$i18n.get({ id: 'aopf.pages.miniAppStore.create.category', dm: '新建类目' })}
        </Button>

        {/* <div className="category-select">
          <span className="category-label">
            {$i18n.get({
              id: 'aopf.pages.miniAppStore.select.category',
              dm: '类目',
            })}
          </span>
          <Checkbox.Group value={categoryType} onChange={onChange} aria-labelledby="groupId">
            <Tooltip
              v2
              trigger={
                <Checkbox id="system" value="system">
                  {$i18n.get({
                    id: 'aopf.pages.miniAppStore.select.systematicCategory.manage',
                    dm: '系统类目管理',
                  })}
                </Checkbox>
              }
              align="t"
            >
              {$i18n.get({
                id: 'aopf.pages.miniAppStore.select.systematicCategory.manage.des',
                dm: '系统类目是小程序的通用分类，小程序开发者在创建小程序时需要选择',
              })}
            </Tooltip>
            <Tooltip
              v2
              trigger={
                <Checkbox id="operation" value="operation">
                  {$i18n.get({
                    id: 'aopf.pages.miniAppStore.select.operationCategory.manage',
                    dm: '运营类目管理',
                  })}
                </Checkbox>
              }
              align="t"
            >
              {$i18n.get({
                id: 'aopf.pages.miniAppStore.select.operationCategory.manage.des',
                dm: '运营类目是App运营人员根据运营目的创建的类目，仅在store页中使用',
              })}
            </Tooltip>
          </Checkbox.Group>
        </div> */}
      </div>
      <DragList
        visible={visible}
        loading={loading}
        setVisible={setVisible}
        dataSource={dataSource}
        setDetailDataSource={setDetailDataSource}
        setEditStatus={setEditStatus}
        initData={initData}
      />
      <CalculateComponent
        otherWidth={280}
        otherHeight={108 + 80 + 80}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />

      <CreateDrawer
        visible={visible}
        setVisible={setVisible}
        // setCreateTitle={setCreateTitle}
        data={detailDataSource}
        status={editStatus}
        initData={initData}
      />
    </div>
  );
};

export default CategoryList;
